import { HttpClient, HttpHeaders } from '@angular/common/http'
import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  OnDestroy,
  ElementRef
} from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import * as XLSX from 'xlsx'
import { MatDatepickerInputEvent } from '@angular/material/datepicker'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { NavigationEnd, Router } from '@angular/router'
import { NgxSpinnerService } from 'ngx-spinner'
import { fromEvent, merge, Observable, of as observableOf } from 'rxjs'
import {
  catchError,
  debounceTime,
  filter,
  map,
  startWith,
  switchMap
} from 'rxjs/operators'
import {
  Lector,
  RequestContainers,
  ResponseConfirmProductsReceiving,
  ResponseConteinerInsertProductsReceivingProducts,
  ResponseItemsConf,
  ResponseUSer,
  ResponseViewContainers
} from 'src/app/_models'
import { AuthenticationService } from 'src/app/_services'
import { ContainerListService } from 'src/app/_services/container-list.service'
import { environment } from 'src/environments/environment'
import Swal from 'sweetalert2'
import { CodeBarScannerComponent } from '../modal/code-bar-scanner/code-bar-scanner.component'
import { MatTableDataSource } from '@angular/material/table'
import { MatDialog } from '@angular/material/dialog'
import { ConfirmContainerItemsComponent } from '../modal/confirm-container-items/confirm-container-items.component'
import { MatAutocompleteTrigger } from '@angular/material/autocomplete'
import { ProduuctsSelect } from '../receive/receive.component'
import { AddProductsModalComponent } from '../modal/add-products-modal/add-products-modal.component'
import { ContainerListPdfComponent } from '../modal/container-list-pdf/container-list-pdf.component'
import domtoimage from 'dom-to-image'
import { jsPDF } from 'jspdf'
import { ContainerBillOfLadingComponent } from '../modal/container-bill-of-lading/container-bill-of-lading.component'
import { MatSelect } from '@angular/material/select'
@Component({
  selector: 'app-containers',
  templateUrl: './containers.component.html',
  styleUrls: ['./containers.component.css']
})
export class ContainersComponent implements OnInit, AfterViewInit, OnDestroy {
  FormConfirmItems: FormGroup
  idEditItemsContainerConfirm = 0
  arrayBilloflading = []
  arrayDataConFirm: ResponseConteinerInsertProductsReceivingProducts[]
  DatosSelectProduct: any
  ArrayProdutsItems = []
  ArrayLocations = []
  myControl = new FormControl()
  options: ProduuctsSelect[] = []
  options2: ProduuctsSelect[] = []
  filteredOptions: Observable<ProduuctsSelect[]>
  datosinicio = ''
  checked2 = false
  datosEditAddProduct: ResponseConfirmProductsReceiving
  isLDT = true
  viewEditItemsContainer = false
  EditItemsContainerID = 0
  viewTable = false
  arrayItemsContainer = []
  arrayItemsContainerSummary = []
  mySubscription: any
  FormItemsContainer: FormGroup
  currentUser: ResponseUSer
  viewAddProduct=false;
  viewConfirmProduts=false;
  viewBillofLading=false;
  Toast = Swal.mixin({
    toast: true,
    position: 'center',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    background: ' #ffffff29',

    padding: '80px 20px 80px',

    didOpen: toast => {
      Swal.showLoading()
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })
  ArrayDetailsConfirmItems = []

  editar = false
  update: any
  SelectEstatus: any
  CustomerView = []
  ContainerForm: FormGroup
  toppings = new FormControl()
  @ViewChild('auto') autocomplete: MatAutocompleteTrigger
  ArrayEstatusContenedor = []
  newContainer: RequestContainers
  selected: any
  checked = false
  actived = true
  displayedColumns: string[] = [
    'Options',
    'Customer',
    'Container',
    'References',
    'Arrived',
    'Empty',
    'Departed',
    'Location',
    'Pieces',
    'Available',
    'Status',
    'Active',
    'Notes',
    'po'
  ]
  ContainerListService: ContainerListService | null
  data: ResponseViewContainers[] = []
  datasourceConteiner: MatTableDataSource<ResponseViewContainers>
  @ViewChild('tablePaginator') paginatorSearch: MatPaginator
  @ViewChild('tablematSort') sortSearch: MatSort
  @ViewChild('selectitemsComfir') selectitemsComfir

  resultsLength = 0
  isLoadingResults = true
  isRateLimitReached = false
  active = 0
  From: Date
  To: Date
  ViewTab = new FormControl(0)
  fecha = new Date()
  date = new FormControl(
    new Date(this.fecha.setMonth(this.fecha.getMonth() + 1))
  )
  date2 = new FormControl(
    new Date(this.fecha.setMonth(this.fecha.getMonth() - 2))
  )
  dateArrived = new FormControl(new Date())
  @ViewChild(MatPaginator) paginator: MatPaginator
  @ViewChild(MatSort) sort: MatSort
  th: any
  events: string[] = []
  arrayDatosExport = []
viewbuttonbilloflading=false;
  ocultarT = false

  totalTable = 0
  labelCust = ''
  arrayIte: ResponseItemsConf[]
  typesummary=0;
  tablepalletNumber = false
  tablePalletQuantity = false
  labelAddConf = 'Add'
  referenceContainer = ''
  @ViewChild('locations') locationsSelect: MatSelect
  constructor (
    private _httpClient: HttpClient,
    private formBuilder: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private spinner: NgxSpinnerService
  ) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(events => {
        this.authenticationService.currentUser.subscribe(
          x => (this.currentUser = x)
        )
      })
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false
    }
    this.mySubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        console.log('ddddd')
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = true
      }
    })
    this.CustomerView = []
    this.ArrayEstatusContenedor = []
    this.arrayItemsContainer = []
    this.ArrayProdutsItems = []
    this.ArrayLocations = []
    this.ArrayDetailsConfirmItems = []
    this.arrayBilloflading = []
    this.OnSelectLocations('')
    if (this.authenticationService.currentUserValue.company == 'LDT20') {
      this.isLDT = false
    }
    this.arrayDataConFirm = []
    this.arrayIte = []

    this.arrayDatosExport = []
    this.arrayItemsContainerSummary = []
    this.OnSelectCostumer()
    this.OnSelectEstatusContenedor()
  }

  ngOnInit (): void {
    this.To = this.date.value
    this.From = this.date2.value
    this.FormItemsContainer = this.formBuilder.group({
      itemNumber: [''],
      quantity: [1, Validators.required],
      pallet: [1, Validators.required],
      weight: [1],
      location: [''],
      proNumber: [''],
      type: ['CTNS'],
      Note: ['']
    })

    this.ContainerForm = this.formBuilder.group({
      custom: ['', Validators.required],
      contenedor: ['', Validators.required],
      referencia: ['', Validators.required],
      arrived: ['', Validators.required],
      empty: [''],
      departed: [''],
      location: [''],
      total: [1],
      available: [1],
      notes: [''],
      estatus: ['', Validators.required],
      actived: [true],
      po: ['']
    })

    this.FormConfirmItems = this.formBuilder.group({
      itemsContainer: ['', Validators.required],
      palletNumber: [1],
      palletQty: [1],
      Qty: [1, Validators.required],
      typePallet: ['CTNS', Validators.required],
      weight_items: [0]
    })

    this.OnViewContainer()
  }

  ngAfterViewInit () {
    console.log(this.dateArrived.value)
    console.log(new Date().setHours(0,0,0,0))

    this.DataContenedor.arrived.setValue(new Date(new Date().setHours(0,0,0,0)))
    const main = <HTMLInputElement>document.getElementById('SubMenu')

    fromEvent(main, 'mouseenter')
      .pipe(
        switchMap(event => {
          console.log('show')
          main.style.display = 'block'
          return fromEvent(main, 'mouseleave').pipe(debounceTime(500))
        })
      )
      .subscribe(val => {
        console.log('hide')
        main.style.display = 'none'
      })

    try {
    } catch (error) {}
  }
  ngOnDestroy (): void {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe()
    }
    var element = document.getElementById('SubMenu')
    element.style.display = 'none'

    localStorage.setItem('header', '0')
  }
  get DataContenedor () {
    return this.ContainerForm.controls
  }

  addEventfrom (type: string, event: MatDatepickerInputEvent<Date>) {
    this.From = event.value
  }
  addEventto (type: string, event: MatDatepickerInputEvent<Date>) {
    this.To = event.value
  }
  OnViewContainer () {
    this.OnChangeLoader()

    this.ContainerListService = new ContainerListService(this._httpClient)
    var it = 0
    if (this.checked) {
      it = 0
    } else {
      it = 1
    }

    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true
          return this.ContainerListService!.getRepoIssues(
            Number(it),
            this.From,
            this.To
          )
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false
          this.isRateLimitReached = false
          this.resultsLength = data.length

          return data
        }),
        catchError(() => {
          this.isLoadingResults = false
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true
          return observableOf([])
        })
      )
      .subscribe(data => {
        this.data = data
        this.datasourceConteiner = new MatTableDataSource(this.data)
        this.datasourceConteiner.sort = this.sortSearch
        this.datasourceConteiner.paginator = this.paginatorSearch
      })
  }
  keytab (event) {
    let element = event.srcElement.id // get the sibling element
    event.preventDefault()
    console.log(event)

    if (event.keyCode === 13 && event.target.nodeName == 'SELECT') {
      console.log('Entro')
      var form = event.target.closest('form')
      var index = Array.prototype.indexOf.call(form, event.target)
      form.elements[index + 1].focus()
      return false
    }
  }

  OnEditarContainer (datos: ResponseViewContainers) {
    this.spinner.show()
    console.log(datos)
    // this.OnChangeLoader()
    var idc = datos.Customer.split('-|')
    var cust = idc[1].replace(' ', '')
    console.log(idc, cust)

    this.labelCust = datos.Customer
    this.update = Number(datos.Id)
    this.editar = true
    try {
      this.DataContenedor.custom.setValue(Number(cust))
    } catch (error) {}
    try {
      this.DataContenedor.contenedor.setValue(String(datos.ContainerNumber))
    } catch (error) {}
    try {
      this.DataContenedor.referencia.setValue(String(datos.ReferenceNumber))
    } catch (error) {}
    try {
      this.referenceContainer = String(datos.ReferenceNumber)
    } catch (error) {}
    try {
      this.DataContenedor.location.setValue(datos.Location)
    } catch (error) {}

    try {
      this.DataContenedor.arrived.setValue(
        new Date(datos.Arrived)
      )
    } catch (error) {}

    try {
      this.DataContenedor.empty.setValue(
        new Date(datos.Empty)
      )
    } catch (error) {}

    try {
      this.DataContenedor.departed.setValue(
        new Date(datos.Departed)
      )
    } catch (error) {}
    try {
      this.th = this.FilterStatus(datos.Status)
      this.DataContenedor.estatus.setValue(this.th[0].key)
    } catch (error) {}
    // SelectEstatusthis.=datos.Status;
    try {
      this.DataContenedor.total.setValue(Number(datos.Pieces))
    } catch (error) {}
    try {
      this.DataContenedor.available.setValue(Number(datos.Available))
    } catch (error) {}
    try {
      this.DataContenedor.notes.setValue(String(datos.Notes))
    } catch (error) {}
    try {
      this.DataContenedor.actived.setValue(Number(datos.Active))
      this.viewbuttonbilloflading=datos.Active
    } catch (error) {}
    try {
      this.DataContenedor.po.setValue(String(datos.po))
    } catch (error) {}
    this.spinner.hide()
    this.spinner.show()
    setTimeout(() => {
      this.onChangeItemTableNew()
      this.OnSelectItemsContainer()
      this.OnSelectProductsItems()
    
      this.OnSelectBillOfLading()
   
      this.ViewTab = new FormControl(1)
      setTimeout(() => {
        this.OnSelectSummaryViewPanel()
        this.spinner.hide()
      }, 1200)
    }, 1200)
  }

  OnChangeConfirmTranfes (datos: ResponseViewContainers) {
    this.spinner.show()
    var idc = datos.Customer.split('-|')
    var cust = idc[1].replace(' ', '')
    console.log(idc, cust)
    this.update = datos.Id
    this.editar = true
    this.DataContenedor.custom.setValue(Number(cust))
    this.DataContenedor.contenedor.setValue(datos.ContainerNumber)
    this.DataContenedor.referencia.setValue(datos.ReferenceNumber)
    this.DataContenedor.location.setValue(datos.Location)
    try {
      this.DataContenedor.arrived.setValue(
        new Date(new Date(datos.Arrived))
      )
    } catch (error) {}
    try {
      this.DataContenedor.empty.setValue(
        new Date(new Date(datos.Empty))
      )
    } catch (error) {}
    try {
      this.DataContenedor.departed.setValue(
        new Date(new Date(datos.Departed))
      )
    } catch (error) {}

    this.th = this.FilterStatus(datos.Status)
    this.DataContenedor.estatus.setValue(this.th[0].key)
    // SelectEstatusthis.=datos.Status;
    this.DataContenedor.total.setValue(datos.Pieces)
    this.DataContenedor.available.setValue(datos.Available)
    this.DataContenedor.notes.setValue(datos.Notes)
    this.DataContenedor.actived.setValue(datos.Active)
    this.viewbuttonbilloflading=datos.Active
    this.DataContenedor.po.setValue(datos.po)
    this.OnTransferInventoryToReceive(datos)
    setTimeout(() => {
      this.DataContenedor.actived.setValue(false)
      this.OnNewContainer(this.update)
    }, 7000)
    setTimeout(() => {
      this.OnCancel()
      setTimeout(() => {
        this.OnViewContainer()
      }, 1000)
    }, 7000)
  }

  OnNewContainer (dataTipo: any) {
   // this.OnChangeLoader()
   this.spinner.show();
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    this.newContainer = {
      tblCustomerID: this.DataContenedor.custom.value,
      containerNumber: this.DataContenedor.contenedor.value || ' ',
      referenceNumber: this.DataContenedor.referencia.value || ' ',
      arrivedDate:
        this.DataContenedor.arrived.value ||
        new Date(new Date().setHours(0,0,0,0)),
      emptyDate: this.DataContenedor.empty.value || null,
      departedDate: this.DataContenedor.departed.value || null,
      tblWarehouseContainerStatusID: this.DataContenedor.estatus.value,
      warehouseLocation: this.DataContenedor.location.value || ' ',
      pieces: this.DataContenedor.total.value || 1,
      available: this.DataContenedor.available.value || 1,
      notes: this.DataContenedor.notes.value || ' ',
      active: Number(this.DataContenedor.actived.value),
      tipo: Number(dataTipo),
      po: this.DataContenedor.po.value || ' '
    }
    this.referenceContainer = this.DataContenedor.referencia.value

    console.log('datosupdate', this.newContainer)
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Containers/ContainersNew`,
        this.newContainer,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        this.spinner.hide();
        this.spinner.show();
        console.log('respuesta', response)
      setTimeout(() => {
        try {
          var txt = String(response.responses)
          if (txt.includes('insert-')) {
            this.update = Number(txt.replace('insert-', ''))
            this.editar = true
            this.actived = true
            this.OnSelectProductsItems();
            this.OnSelectItemsContainer()
            this.onChangeItemTableNew()
            this.spinner.hide();
          } else if (txt.includes('update-')) {
            this.update = Number(txt.replace('update-', ''))
            this.editar = true
            this.OnSelectProductsItems();
            this.OnSelectItemsContainer()
            this.onChangeItemTableNew()
           
            this.spinner.hide();
          } else {
            this.spinner.hide();
            alert('error')
          }
         } catch (error) {
          this.spinner.hide();
         }
      }, 1200);
        //this.OnCancel();

        //      this.OnViewContainer();
      })
  }
  onInsertStatusReceiving (OrderId: Number) {
    var Request = {}

    Request['OrderId'] = Number(OrderId)
    Request['status'] = String('DELIVERED/COMPLETE')

    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/ReceivingStatusInsert`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {})
  }
  OnSelectCostumer () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['companyId'] = json.companyIdWh
    Request['active'] = '1'

    this._httpClient
      .post<any>(`${environment.apiUrl}/Shipping/PlaceOrderCustomer`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token
        })
      })
      .subscribe((response: any) => {
        this.CustomerView = response
      })
  }
  OnSelectEstatusContenedor () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['companyId'] = json.companyIdWh
    Request['active'] = '1'

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Containers/ContainersViewEstaus`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        this.ArrayEstatusContenedor = response
      })
  }
  isSelected (index: number) {
    if (index == 0 && this.update != null) {
      return true
    } else {
      return false
    }
  }
  OnCancel () {
    this.update = 0
    this.editar = false
    this.selected = null
    this.FormItemsContainer.reset()
    this.FormConfirmItems.reset()
    this.arrayItemsContainer = []
    this.ArrayDetailsConfirmItems = []
    this.arrayBilloflading = []
    this.idEditItemsContainerConfirm = 0
this.viewAddProduct=false;
this.viewConfirmProduts=false;
this.viewBillofLading=false;
this.arrayItemsContainerSummary=[];
this.options=[]
this.options2=[]
    this.DataContenedor.custom.setValue(null)
    this.DataContenedor.contenedor.setValue(' ')
    this.DataContenedor.referencia.setValue(' ')
  
    this.DataContenedor.arrived.setValue(
      new Date(new Date().setHours(0,0,0,0))
    )
    this.DataContenedor.empty.setValue(
      new Date(new Date().setHours(0,0,0,0))
    )
    this.DataContenedor.departed.setValue(
      new Date(new Date().setHours(0,0,0,0))
    )
    this.DataContenedor.estatus.setValue(null)
    this.DataContenedor.location.setValue(null)
    this.DataContenedor.total.setValue(1)
    this.DataContenedor.available.setValue(1)
    this.DataContenedor.notes.setValue('')
    this.DataContenedor.actived.setValue(1)
    this.viewbuttonbilloflading=false

    this.DataContenedor.po.value || ' '
    this.actived = true
    this.tablepalletNumber = false
    this.tablePalletQuantity = false
    this.viewTable = false
    this.ViewTab = new FormControl(0)
  }
  OnChangeLoader () {
    this.spinner.show()

    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide()
    }, 5000)
  }
  FilterStatus (locationName: string) {
    return this.ArrayEstatusContenedor.filter(object => {
      if (object['value'] == locationName) {
        return object
      }
    })
  }
  @ViewChild('exportExcel') table: ElementRef
  exportAsExcel () {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.table.nativeElement
    ) //converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

    /* save to file */
    XLSX.writeFile(wb, 'SheetJS.xlsx')
  }
  datosLector: Lector

  applyFilterSearch (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.datasourceConteiner.filter = filterValue.trim().toLowerCase()

    if (this.datasourceConteiner.paginator) {
      this.datasourceConteiner.paginator.firstPage()
    }
  }
  openDialogLector (): void {
    const dialogRef = this.dialog.open(CodeBarScannerComponent, {
      width: '300px',
      data: this.datosLector
    })

    dialogRef.afterClosed().subscribe(result => {
      this.DataContenedor.filter = result.Resultado.trim().toLowerCase()

      if (this.datasourceConteiner.paginator) {
        this.datasourceConteiner.paginator.firstPage()
      }
    })
  }

  onAddItemsContainer () {
    this.spinner.show()
    this.DatosSelectProduct = this.myControl.value
    var js = {
      containerId: Number(this.update),
      locationId: Number(this.FormItemsContainer.controls.location.value),
      itemNumber: String(this.DatosSelectProduct.ItemNumber),
      quantity: Number(this.FormItemsContainer.controls.quantity.value),
      receiveQuantity: 0,
      palletQuantity: Number(this.FormItemsContainer.controls.pallet.value),
      weight: Number(this.FormItemsContainer.controls.weight.value),
      active: 1,
      proNumber: '',
      type: String(this.FormItemsContainer.controls.type.value),
      idProduct: Number(this.DatosSelectProduct.id),
      note: String(this.FormItemsContainer.controls.Note.value)
    }

    this._httpClient
      .post<any>(`${environment.apiUrl}/Containers/ContainersItemsNew`, js, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization:
            'Bearer ' + this.authenticationService.currentUserValue.token
        })
      })
      .subscribe((response: any) => {
        this.spinner.hide()
        this.spinner.show()
        try {
          this.OnSelectProductsItems()
          this.OnSelectItemsContainer()
        } catch (error) {
          
        }
        setTimeout(() => {
          
         

         setTimeout(() => {
          this.FormItemsContainer.reset({
            itemNumber: [''],
            quantity: [1, Validators.required],
            pallet: [1, Validators.required],
            weight: [1],
            location: [''],
            proNumber: [''],
            type: ['CTNS'],
            Note: ['']
          })
          this.FormItemsContainer.controls.quantity.setValue(1)
          this.FormItemsContainer.controls.pallet.setValue(1)
          this.FormItemsContainer.controls.weight.setValue(1)

          this.FormItemsContainer.controls.proNumber.setValue('')
          this.FormItemsContainer.controls.type.setValue('CTNS')
          this.FormItemsContainer.controls.Note.setValue('')
          this.spinner.hide()
         }, 600);
        }, 1200)
      })
  }

  OnSelectItemsContainer () {
    this.arrayItemsContainer = []
    this.viewTable = false
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Containers/containerreceiveitemsSelect?ContainerID=${Number(
          this.update
        )}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.arrayItemsContainer = response
        this.viewTable = true
      })
  }

  OnDeleteItemsContainer (Data: any) {
    this.spinner.show();
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Containers/containerreceiveitemsDeletet?ContainerID=${Number(
          Data.receiveItemsID
        )}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.spinner.hide();
        this.spinner.show();
        setTimeout(() => {
          this.onChangeItemTableNew()
          this.OnSelectItemsContainer()
          this.spinner.hide();
        }, 1200);
      })
  }

  OnEditarItemsContainer (Datas: any) {
    document.getElementById('product').click()
    //this.OnSelectProductsItems();
    try {
      var ta = this.options2.filter(option =>
        option.id.toString().toLowerCase().indexOf(String(Datas.idProduct)) === 0
          ? option
          : option.id.toString().toLowerCase().indexOf(
              String(Datas.idProduct)
            ) === 0
      )
      console.log(ta)
      this.myControl.setValue(ta[0])

      this.EditItemsContainerID = Datas.receiveItemsID
      this.FormItemsContainer.controls.itemNumber.setValue(
        String(Datas.ItemNumber)
      )
      this.FormItemsContainer.controls.quantity.setValue(Number(Datas.Quantity))
      this.FormItemsContainer.controls.pallet.setValue(
        Number(Datas.palletQuantity)
      )
      this.FormItemsContainer.controls.weight.setValue(
        Number(Datas.weightTotal)
      )
   this.onSearchEditItemsContainer(Datas.Location,Datas.LocationId)
      this.FormItemsContainer.controls.proNumber.setValue(
        String(Datas.proNumber)
      )
      this.FormItemsContainer.controls.type.setValue(String(Datas.type_items))
      this.viewEditItemsContainer = true
    } catch (error) {}
  }
  onSearchEditItemsContainer(search:any,LocationId:any){
    this._httpClient
    .get<any>(
      `${environment.apiUrl}/Administracion/SearchLocationsNew?companyId=${Number(this.authenticationService.currentUserValue.companyIdWh)}&active=1&search=${String(search)}`,
     
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization:
            'Bearer ' + this.authenticationService.currentUserValue.token
        })
      }
    )
    .subscribe((response: any) => {
      this.ArrayLocations = response
      this.FormItemsContainer.controls.location.setValue(
        Number(LocationId)
      )
    })
  }
  onUpdateItemsContainer () {
    this.DatosSelectProduct = this.myControl.value
    var js = {
      containerId: Number(this.update),
      locationId: Number(this.FormItemsContainer.controls.location.value),
      itemNumber: String(this.DatosSelectProduct.ItemNumber),
      quantity: Number(this.FormItemsContainer.controls.quantity.value),
      receiveQuantity: 0,
      palletQuantity: Number(this.FormItemsContainer.controls.pallet.value),
      weight: Number(this.FormItemsContainer.controls.weight.value),
      active: 1,
      proNumber: '',
      type: String(this.FormItemsContainer.controls.type.value),
      idProduct: Number(this.DatosSelectProduct.id),
      note: String(this.FormItemsContainer.controls.Note.value)
    }

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Containers/ContainersItemsUpdate?ID=${Number(
          this.EditItemsContainerID
        )}`,
        js,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.OnSelectItemsContainer()
        this.viewEditItemsContainer = false
        this.FormItemsContainer.reset({
          itemNumber: [''],
          quantity: [1, Validators.required],
          pallet: [1, Validators.required],
          weight: [1],
          location: [''],
          proNumber: [''],
          type: ['CTNS'],
          Note: ['']
        })
        this.FormItemsContainer.controls.itemNumber.setValue('')
        this.FormItemsContainer.controls.quantity.setValue(1)
        this.FormItemsContainer.controls.weight.setValue(1)
        this.FormItemsContainer.controls.pallet.setValue(1)
        this.FormItemsContainer.controls.location.setValue('')
        this.FormItemsContainer.controls.proNumber.setValue('')
        this.FormItemsContainer.controls.type.setValue('CTNS')
        this.FormItemsContainer.controls.Note.setValue('')
        this.myControl.patchValue('', { emitEvent: true })
      })
  }

  OnConfirmItemsContainer (datos: ResponseViewContainers) {
    console.log(datos)

    this.update = datos.Id
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Containers/containerreceiveitemsSelect?ContainerID=${Number(
          this.update
        )}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        console.log(datos)
        const dialogRef = this.dialog.open(ConfirmContainerItemsComponent, {
          width: '100vw',
          height: '100vh',
          data: { container: datos, arrayitems: response }
        })

        dialogRef.afterClosed().subscribe(result => {
          console.log('The dialog was closed')
          // this.animal = result;
        })
      })
  }

  onKeydown (e) {
    console.log(e)
    
    this.options = this.options2
    this.autocomplete.openPanel()
    this.datosinicio = ''
   
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => (typeof value === 'string' ? value : value)),
      map(name => (name ? this._filter(name) : this.options.slice()))
    )
  }
  displayFn (user: ProduuctsSelect): string {
    try {
      return user && user.ItemNumber ? user.ItemNumber : user.ItemDescription
    } catch (error) {}
  }

  private _filter (name: string): ProduuctsSelect[] {
    const filterValue = String(name).toLowerCase()

    return this.options.filter(option =>
      option.ItemNumber.toLowerCase().indexOf(filterValue) === 0
        ? option
        : option.ItemDescription.toLowerCase().indexOf(filterValue) === 0
    )
  }
  OnSelectProductsItems () {
    var Request = {}
    Request['companyId'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Request['customerId'] = Number(this.ContainerForm.controls.custom.value)
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/ReceivingProdutsItems`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: ProduuctsSelect[]) => {
        this.ArrayProdutsItems = []
        this.options = []
        this.options2 = []
        try {
          this.myControl.patchValue('', { emitEvent: true })
          this.ArrayProdutsItems = response
          this.options = response
          this.options2 = response
          this.filteredOptions = this.myControl.valueChanges.pipe(
            startWith(''),
            map(value => (typeof value === 'string' ? value : value)),
            map(name => (name ? this._filter(name) : this.options.slice()))
          )
        } catch (error) {}
      })
  }

  OnSelectLocations (search:any) {

    var ss=String(search)
    
if (ss=='') {
  
  this._httpClient
  .get<any>(
    `${environment.apiUrl}/Administracion/SearchLocationsNew?companyId=${Number(this.authenticationService.currentUserValue.companyIdWh)}&active=1&search=${String(search)}`,
   
    {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Methods': '*',
        Authorization:
          'Bearer ' + this.authenticationService.currentUserValue.token
      })
    }
  )
  .subscribe((response: any) => {
    this.ArrayLocations = response
  })
} else {
  if (ss.length>3) {
    
    this._httpClient
      .get<any>(
        `${environment.apiUrl}/Administracion/SearchLocationsNew?companyId=${Number(this.authenticationService.currentUserValue.companyIdWh)}&active=1&search=${String(search)}`,
       
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.ArrayLocations = response
        this.locationsSelect.open();
      })
  } else {
    
  }
}


  }
  applyFilterLocation (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
  
this.OnSelectLocations(filterValue.trim().toLowerCase())
   
  }
  ModalProducts (): void {
    this.datosLector = {
      Resultado: '',
      modulo: String(this.ContainerForm.controls.custom.value)
    }
    const dialogRef = this.dialog.open(AddProductsModalComponent, {
      width: '100vf',
      height: '100vf',
      data: this.datosLector
    })

    dialogRef.afterClosed().subscribe(result => {
      if (
        result.Resultado == '' ||
        result.Resultado == null ||
        result.Resultado == undefined
      ) {
        this.OnSelectProductsItems()
        document.getElementById('product').click()
      } else {
        this.OnSelectProductsItemsmodal(result)
      }
    })
  }
  OnSelectProductsItemsmodal (data: any) {
    console.log(data)
    var Request = {}
    Request['companyId'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Request['customerId'] = Number(this.ContainerForm.controls.custom.value)
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/ReceivingProdutsItems`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: ProduuctsSelect[]) => {
        this.ArrayProdutsItems = response
        this.options = response
        this.options2 = response
        this.datosinicio = data.Resultado
        try {
          document.getElementById('product').click()

          this.filteredOptions = this.myControl.valueChanges.pipe(
            startWith(this.datosinicio || ''),
            map(value => (typeof value === 'string' ? value : value)),
            map(name => (name ? this._filter(name) : this.options.slice()))
          )
        } catch (error) {
          console.log(error)
        }
      })
  }

  filterDataCustomerSearchOrder (locationName: number) {
    return this.ArrayLocations.filter(object => {
      if (
        String(object.id).toUpperCase() == String(locationName).toUpperCase()
      ) {
        return object
      }
    })
  }

  onSearchLocation (da: any) {
    var lo = ''
    var arr
    try {
      arr = this.filterDataCustomerSearchOrder(Number(da))

      lo = arr[0].location
    } catch (error) {
      lo = ''
    }
    return lo
  }

  OnTransferInventoryToReceive (data: any) {
    var Request = {}

    Request['tipo'] = 0

    Request['tblCompanyID'] = String(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Request['tblCustomerID'] = String(this.ContainerForm.controls.custom.value)
    Request['ReferenceNumber'] = String(
      this.ContainerForm.controls.referencia.value || ' '
    )
    Request['ETA'] = this.ContainerForm.controls.arrived.value || ''
    Request['ReceivedDate'] = this.ContainerForm.controls.arrived.value || ''
    Request['CarrierName'] = String('')
    Request['BOLNumber'] = ''
    Request['PONumber'] = String(this.ContainerForm.controls.po.value)
    Request['ContainerNumber'] = String(
      this.ContainerForm.controls.contenedor.value
    )
    Request['SealNumber'] = String('')
    Request['MiscText'] = String(
      'CONTAINER CONCENTRATOR ACCOUNT-' + String(data.Id) || '  '
    )
    Request['CapacityType'] = String(1)
    Request['DoorNumber'] = String('')
    Request['Notes'] = String(this.ContainerForm.controls.notes.value)
    Request['Completed'] = '0'
    Request['CompletedDate'] = ''
    Request['DateCreated'] = new Date(new Date().setHours(0,0,0,0))
    Request['TotalPallets'] = String(this.ContainerForm.controls.total.value)

    Request['Users'] = String(
      this.authenticationService.currentUserValue.useremail
    )

    Request['Billed'] = Number('0')
    //this.FormReceivingProducts.controls.AllChargesAdded.value
    Request['AllChargesAdded'] = Number('0')
    Request['HandlingCharge'] = Number('0')
    Request['ShortTermStorage'] = Number('0')

    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/ReceivingProductsNewEdit`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        var Registro = response.responses
        try {
          var ids = String(Registro)
          var rep = ids
            .replace('receiving-new-', '')
            .replace('receiving-edit-', '')
          Registro = Number(rep)
          this.onInsertStatusReceiving(Registro)
          this.OnSelectDataItems(Registro)
        } catch (error) {}
      })
  }

  OnSelectDataItems (dataa: any) {
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Containers/ContainerReceivingDataInsertSelect?ContainerID=${Number(
          this.update
        )}&tblReceivingProductsID=${Number(dataa)}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe(
        (response: ResponseConteinerInsertProductsReceivingProducts[]) => {
          this.arrayDataConFirm = response
          console.log(response, 'select')
          this.OnNewOrEditProdutsLsit(dataa, this.arrayDataConFirm)
        }
      )
  }

  OnNewOrEditProdutsLsit (
    id: any,
    data: ResponseConteinerInsertProductsReceivingProducts[]
  ) {
    for (let index = 0; index < data.length; index++) {
      const element = data[index]
      var Request = {}
      console.log(this.myControl.value)
      Request['tipo'] = Number(element.tipo)
      Request['tblReceivingProductsID'] = Number(element.tblReceivingProductsID)
      Request['tblProductID'] = Number(element.tblProductID)
      Request['LotNumber'] = element.LotNumber
      Request['StatedQuantity'] = String(element.StatedQuantity || '1')
      Request['ActualQuantity'] = String(element.ActualQuantity || '0')
      Request['Discrepancy'] = String(element.Discrepancy || '0')
      Request['AvailableQuantity'] = String(element.AvailableQuantity || '0')
      Request['tblLocationID'] = String(element.tblLocationID)
      Request['ExpirationDate'] = String(element.ExpirationDate)
      Request['Notes'] = String(element.Notes)
      Request['SerialNumber'] = String(element.SerialNumber)
      Request['Completed'] = Number(element.Completed || 0)
      Request['pallex'] = String(element.pallex || '1')
      Request['CompletedDate'] = new Date(new Date())
      Request['typePallets'] = String(element.typePallets || 'PLTS')
      Request['weightPallets'] = Number(element.weightPallets || 0)
      Request['pto'] = Number(element.pto || index)
      this._httpClient
        .post<any>(
          `${environment.apiUrl}/Receive/ReceivingProdutsItemsNewEditadditional`,
          Request,
          {
            headers: new HttpHeaders({
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': '*',
              'Access-Control-Allow-Methods': '*',
              Authorization:
                'Bearer ' + this.authenticationService.currentUserValue.token
            })
          }
        )
        .subscribe((response: any) => {})
    }

    setTimeout(() => {
      this.OnConfirmProducts(id)
    }, 2000)
  }

  OnConfirmProducts (id: any) {
    const requestUrl = `${environment.apiUrl}/Receive/SearchReceiveProductList`

    var Request = {}
    Request['ReceivingId'] = Number(id)
    Request['ProcessStatus'] = 0

    this._httpClient
      .post<any>(requestUrl, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization:
            'Bearer ' + this.authenticationService.currentUserValue.token
        })
      })
      .subscribe((response: any) => {
        this.OnConfirmar(response)
      })
  }

  OnConfirmar (arr: any) {
    for (let index = 0; index < arr.length; index++) {
      var Request = {}
      Request['tipo'] = Number(arr[index].Id)
      Request['tblProductID'] = Number(arr[index].productID)
      Request['AvailableQuantity'] = String(arr[index].StatedQuantity)
      Request['tblLocationID'] = Number(arr[index].LocationID)
      Request['Notes'] = String(arr[index].Notes)
      Request['PalletAmount'] = Number(arr[index].PalletAmount)

      console.log(Request)
      this._httpClient
        .post<any>(
          `${environment.apiUrl}/Receive/ReceivingConfirmProductUpdate`,
          Request,
          {
            headers: new HttpHeaders({
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': '*',
              'Access-Control-Allow-Methods': '*',
              Authorization:
                'Bearer ' + this.authenticationService.currentUserValue.token
            })
          }
        )
        .subscribe((response: any) => {
          console.log(response)
        })
    }
  }

  openDialog (datas: any): void {
    const dialogRef = this.dialog.open(ContainerListPdfComponent, {
      width: '60vw',
      data: datas.Id,
      height: '100vh'
    })

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed')
    })
  }

  onComplete () {
    this.spinner.show()
    this.OnNewContainer(this.update)
    setTimeout(() => {
      this.OnCancel()
      this.spinner.hide()
    }, 3000)
  }

  OnConfirmItems () {
    console.log(this.arrayIte)
    this.viewTable = false
    this.spinner.show()

    try {
      for (let index = 0; index < this.arrayIte.length; index++) {
        const element = this.arrayIte[index]
        this.onConfirmNewContainerItems(element)
      }
    } catch (error) {}

    setTimeout(() => {
      this.spinner.hide()
      this.onChangeItemTableNew()
      this.OnSelectItemsContainer()

      this.viewTable = true
    }, 1200)
  }

  OnviewTable () {
    if (this.viewTable) {
      this.viewTable = false
    } else {
      this.onChangeItemTableNew()
    }
  }

  onChangeItemTableNew () {
    this.viewTable = false
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Containers/containerreceiveitemsSelectConfirmNew?ContainerID=${Number(
          this.update
        )}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: ResponseItemsConf[]) => {
        this.arrayIte = []
        this.arrayIte = response
        try {
          this.totalTable = 0
          for (let index = 0; index < this.arrayIte.length; index++) {
            const element = this.arrayIte[index]

            this.totalTable += element.qtyexp
          }
        } catch (error) {}
        try {
          if (this.DataContenedor.custom.value == 1265) {
            this.typesummary=1
            this.tablepalletNumber = true
            this.tablePalletQuantity = false
            this.ocultarT = true
          } else if (this.DataContenedor.custom.value == 1264) {
            this.typesummary=0
            this.tablepalletNumber = false
            this.tablePalletQuantity = true
          } else {
            this.tablepalletNumber = true
            this.tablePalletQuantity = false
            this.ocultarT = true
            this.typesummary=0
          }
        } catch (error) {}

        this.viewTable = true
      })
  }

  onConfirmNewContainerItems (datosC: any) {
    console.log(datosC)
    var pt1 = 0
    var pt2 = 0
    var pt3 = 0
    var pt4 = 0
    var pt5 = 0
    var pt6 = 0
    var pt7 = 0
    var pt8 = 0
    var pt9 = 0
    var pt10 = 0
    var pt11 = 0
    try {
      var qt1 = Number(datosC.qty1 || 0)
      var qt2 = Number(datosC.qty2 || 0)
      var qt3 = Number(datosC.qty3 || 0)
      var qt4 = Number(datosC.qty4 || 0)
      var qt5 = Number(datosC.qty5 || 0)
      var qt6 = Number(datosC.qty6 || 0)
      var qt7 = Number(datosC.qty7 || 0)
      var qt8 = Number(datosC.qty8 || 0)
      var qt9 = Number(datosC.qty9 || 0)
      var qt10 = Number(datosC.qty10 || 0)
      var qt11 = Number(datosC.qty11 || 0)

      if (qt1 > 0) {
        pt1 = Number(datosC.ptl1 || 0)
        if (pt1 == 0) {
          pt1 = 1
        }
      } else {
        pt1 = 0
      }

      if (qt2 > 0) {
        pt2 = Number(datosC.ptl2 || 0)
        if (pt2 == 0) {
          pt2 = 1
        }
      } else {
        pt2 = 0
      }

      if (qt3 > 0) {
        pt3 = Number(datosC.ptl3 || 0)
        if (pt3 == 0) {
          pt3 = 1
        }
      } else {
        pt3 = 0
      }

      if (qt4 > 0) {
        pt4 = Number(datosC.ptl4 || 0)
        if (pt4 == 0) {
          pt4 = 1
        }
      } else {
        pt4 = 0
      }

      if (qt5 > 0) {
        pt5 = Number(datosC.ptl5 || 0)
        if (pt5 == 0) {
          pt5 = 1
        }
      } else {
        pt5 = 0
      }

      if (qt6 > 0) {
        pt6 = Number(datosC.ptl6 || 0)
        if (pt6 == 0) {
          pt6 = 1
        }
      } else {
        pt6 = 0
      }

      if (qt7 > 0) {
        pt7 = Number(datosC.ptl7 || 0)
        if (pt7 == 0) {
          pt7 = 1
        }
      } else {
        pt7 = 0
      }

      if (qt8 > 0) {
        pt8 = Number(datosC.ptl8 || 0)
        if (pt8 == 0) {
          pt8 = 1
        }
      } else {
        pt8 = 0
      }

      if (qt9 > 0) {
        pt9 = Number(datosC.ptl9 || 0)
        if (pt9 == 0) {
          pt9 = 1
        }
      } else {
        pt9 = 0
      }

      if (qt10 > 0) {
        pt10 = Number(datosC.ptl10 || 0)
        if (pt10 == 0) {
          pt10 = 1
        }
      } else {
        pt10 = 0
      }

      if (qt11 > 0) {
        pt11 = Number(datosC.ptl11 || 0)
        if (pt11 == 0) {
          pt11 = 1
        }
      } else {
        pt11 = 0
      }

      var jj = {
        tipo: 1,
        id: Number(datosC.id_receive_container_itemsID),
        pto1: Number(datosC.pto1 || 0),
        plts1: Number(pt1 || 0),
        qty1: Number(datosC.qty1 || 0),
        pto2: Number(datosC.pto2 || 0),
        plts2: Number(pt2 || 0),
        qty2: Number(datosC.qty2 || 0),
        pto3: Number(datosC.pto3 || 0),
        plts3: Number(pt3 || 0),
        qty3: Number(datosC.qty3 || 0),
        pto4: Number(datosC.pto4 || 0),
        plts4: Number(pt4 || 0),
        qty4: Number(datosC.qty4 || 0),
        pto5: Number(datosC.pto5 || 0),
        plts5: Number(pt5 || 0),
        qty5: Number(datosC.qty5 || 0),
        pto6: Number(datosC.pto6 || 0),
        plts6: Number(pt6 || 0),

        qty6: Number(datosC.qty6 || 0),
        pto7: Number(datosC.pto7 || 0),
        plts7: Number(pt7 || 0),
        qty7: Number(datosC.qty7 || 0),
        pto8: Number(datosC.pto8 || 0),
        plts8: Number(pt8 || 0),
        qty8: Number(datosC.qty8 || 0),
        pto9: Number(datosC.pto9 || 0),
        plts9: Number(pt9 || 0),
        qty9: Number(datosC.qty9 || 0),
        pto10: Number(datosC.pto10 || 0),
        plts10: Number(pt10 || 0),
        qty10: Number(datosC.qty10 || 0),
        pto11: Number(datosC.pto11 || 0),
        plts11: Number(pt11 || 0),
        qty11: Number(datosC.qty11 || 0),
        NumberInMaster: Number(datosC.NumberInMaster || 1),
        idPr: Number(datosC.idPr)
      }
      console.log(jj)

      this._httpClient
        .post<any>(
          `${environment.apiUrl}/Containers/ContainersItemsUpdateConfimacion`,
          jj,
          {
            headers: new HttpHeaders({
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': '*',
              'Access-Control-Allow-Methods': '*',
              Authorization:
                'Bearer ' + this.authenticationService.currentUserValue.token
            })
          }
        )
        .subscribe((response: any) => {
          console.log(response)
        })
    } catch (error) {}
  }
  onCleaarte (da: string) {
    var text = ''
    try {
      var idc = da.split('-|')
      var cust = idc[0].replace('', '')
      text = cust
    } catch (error) {
      text = da
    }
    return text
  }
  @ViewChild('pdfTable3')
  pdfTable3!: ElementRef
  onExport () {
    let div = this.pdfTable3.nativeElement

    var img: any
    var filename
    var newImage: any
    var img2: any
    var filename2
    var newImage2: any
    var img3: any
    var filename3
    var newImage3: any
    var doc
    this.spinner.show()

    domtoimage
      .toPng(div, { bgcolor: '#fff' })

      .then(function (dataUrl) {
        img = new Image(865, 1400)
        img.src = dataUrl
        newImage = img.src

        img.onload = function () {
          var pdfWidth = img.width
          var pdfHeight = img.height

          // FileSaver.saveAs(dataUrl, 'my-pdfimage.png'); // Save as Image
          doc = new jsPDF('l', 'mm', 'a4', true)

          var width = doc.internal.pageSize.getWidth()
          var height = doc.internal.pageSize.getHeight()
          console.log(width, height)

          doc.addImage(newImage, 'JPEG', 10, 20, 270, 145)
          filename = 'Container' + '.pdf'
          doc.save(filename)
        }
      })
      .catch(function (error) {
        // Error Handling
      })
    this.spinner.hide()
  }

  onoculta () {
    if (this.ocultarT) {
      this.ocultarT = false
    } else {
      this.ocultarT = true
    }
  }

  OnStateReportLinesExport () {
    const wb: XLSX.WorkBook = XLSX.utils.book_new()
    for (let index = 0; index < this.arrayDatosExport.length; index++) {
      const element = this.arrayDatosExport[index]
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(element.datosArray) //converts a DOM TABLE element to a worksheet
      //
      XLSX.utils.sheet_add_aoa(
        ws,
        [['CONTAINER#', element.title], , ['', '', '']],
        { origin: -1 }
      )

      XLSX.utils.book_append_sheet(wb, ws, element.title + '-' + String(index))
    }

    /* save to file */
    XLSX.writeFile(wb, '26items.xlsx')
  }

  OnEditItemsConfirm (data: any) {
    this.FormConfirmItems.controls.itemsContainer.setValue(
      Number(data.id_items_container)
    )
    this.FormConfirmItems.controls.itemsContainer.disable()
    this.FormConfirmItems.controls.palletNumber.setValue(
      Number(data.pallet_number)
    )

    this.FormConfirmItems.controls.palletQty.setValue(Number(data.pallet_qty))

    this.FormConfirmItems.controls.Qty.setValue(Number(data.qty_items))

    this.FormConfirmItems.controls.typePallet.setValue(String(data.type_unit))
    this.FormConfirmItems.controls.weight_items.setValue(
      Number(data.weight_items)
    )
    this.idEditItemsContainerConfirm = Number(data.id_confirm_row)
    this.labelAddConf = 'Update'

    console.log(data, 'datos')
  }

  OninsertUpdateConfirmItems () {
    this.spinner.show();
    console.log(this.FormConfirmItems.controls.itemsContainer)

    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Containers/ContainerItemsConfirmInsertUpdate?tipo=${
          this.idEditItemsContainerConfirm
        }&id_items_container=${
          this.FormConfirmItems.controls.itemsContainer.value
        }&type_unit=${this.FormConfirmItems.controls.typePallet.value ||
          'CTNS'}&qty_items=${this.FormConfirmItems.controls.Qty.value ||
          1}&pallet_qty=${this.FormConfirmItems.controls.palletQty.value ||
          1}&pallet_number=${this.FormConfirmItems.controls.palletNumber
          .value || 1}&weight_items=${this.FormConfirmItems.controls
          .weight_items.value || 1}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.spinner.hide();
        try {
          this.spinner.show();
          setTimeout(() => {
            var te = this.FormConfirmItems.controls.itemsContainer.value
        this.OnselectitemsconfirmContaimer(te)
        this.onChangeItemTableNew()
        
      
        this.OnSelectItemsContainer()
        this.OnSelectSummaryViewPanel()
       setTimeout(() => {
        this.idEditItemsContainerConfirm=0
        this.labelAddConf = 'Add'
        this.FormConfirmItems.reset({
          itemsContainer: ['', Validators.required],
          palletNumber: [1],
          palletQty: [1],
          Qty: [1, Validators.required],
          typePallet: ['CTNS', Validators.required],
          weight_items: [0]
        })
        
        this.selectitemsComfir.open()
        this.selectitemsComfir.focus()
        this.FormConfirmItems.controls.itemsContainer.enable()
        this.FormConfirmItems.controls.Qty.setValue(1)
        this.FormConfirmItems.controls.weight_items.setValue(0)
        this.FormConfirmItems.controls.typePallet.setValue('CTNS')
        if (this.DataContenedor.custom.value == 1265) {
          this.FormConfirmItems.controls.palletNumber.setValue(null)
          this.FormConfirmItems.controls.palletQty.setValue(1)
        } else if (this.DataContenedor.custom.value == 1264) {
          this.FormConfirmItems.controls.palletNumber.setValue(1)
          this.FormConfirmItems.controls.palletQty.setValue(1)
        } else {
          this.FormConfirmItems.controls.palletNumber.setValue(1)
          this.FormConfirmItems.controls.palletQty.setValue(1)
        }
        this.spinner.hide();
       }, 1200);
      
          }, 1200);
        } catch (error) {
          this.spinner.hide();
        }
      })
  }
  OnselectitemsconfirmContaimer (data: any) {
    this.ArrayDetailsConfirmItems = []

    this._httpClient
      .get<any>(
        `${environment.apiUrl}/Containers/itemconfirmdetailsselect?id_items_container=${data}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.ArrayDetailsConfirmItems = response
      })
  }

  OnDeleteitemsconfirmContaimer (data: any) {
    this.spinner.show();
    this._httpClient
      .get<any>(
        `${environment.apiUrl}/Containers/containeritemsrowdetailsconfirmDelete?id_items_container=${data.id_confirm_row}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.spinner.hide();
        this.spinner.show();
       setTimeout(() => {
        this.OnselectitemsconfirmContaimer(
          data.id_items_container
        )
        this.onChangeItemTableNew()
        this.OnSelectItemsContainer()
        this.spinner.hide();
       }, 1200);
      })
  }

  FilterNameProductConfirm (locationName: Number) {
    return this.arrayItemsContainer.filter(object => {
      if (object['receiveItemsID'] == locationName) {
        return object
      }
    })
  }

  onsearchnameProduct (dataa: Number) {
    var label = ''

    try {
      var f = this.FilterNameProductConfirm(dataa)
      label = f[0].ItemNumber
    } catch (error) {}
    return label
  }

  onpdfTable () {
    var url =
      environment.wmsdocument +
      '/Warehouse/ContainerItems?ContainerID=' +
      this.update
    window.open(url)
  }
  onpdfTableSummary () {
    var url =
      environment.wmsdocument +
      '/Warehouse/ContainerItemsSummary?ContainerID=' +
      this.update
    window.open(url)
  }

  onpdfTablePageLabel () {
    var url =
      environment.wmsdocument +
      '/Warehouse/ContainerItemsLabel?ContainerID=' +
      this.update +
      '&company=' +
      this.authenticationService.currentUserValue.companyIdWh
    window.open(url)
  }
  onpdfTableBillOfLading () {
    var url =
      environment.wmsdocument +
      '/Warehouse/Fractioncontainer?ContainerID=' +
      this.update
    window.open(url)
  }

  openDialogPdfPageLabelContainer (): void {
    const dialogRef = this.dialog.open(ContainerBillOfLadingComponent, {
      width: '100vw',
      height: '100vh',
      data: {
        tipo: 0,
        idcontainer: this.update,
        datar: [],
        conteiner: this.DataContenedor.contenedor.value
      }
    })

    dialogRef.afterClosed().subscribe(result => {
      this.OnSelectBillOfLading()
    })
  }

  OnSelectBillOfLading () {
    this.arrayBilloflading = []
    this._httpClient
      .get<any>(
        `${environment.apiUrl}/Containers/containerbillofladingselect?tblcontainerID=${this.update}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.arrayBilloflading = response
      })
  }

  openDialogPdfPageLabelContainerEdit (data: any): void {
    const dialogRef = this.dialog.open(ContainerBillOfLadingComponent, {
      width: '100vw',
      height: '100vh',
      data: {
        tipo: Number(data.id_bill),
        idcontainer: this.update,
        datar: data,
        conteiner: this.DataContenedor.contenedor.value
      }
    })

    dialogRef.afterClosed().subscribe(result => {
      this.OnSelectBillOfLading()
    })
  }
  OnSelectBillOfLadingDelete (datas: any) {
    this._httpClient
      .get<any>(
        `${environment.apiUrl}/Containers/containerbillofladingDelete?id=${datas}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.OnSelectBillOfLading()
      })
  }
  OnSelectSummaryViewPanel () {
    this.arrayItemsContainerSummary = []

    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Containers/ContainerSummaryViewPanel?ContainerID=${Number(
          this.update
        )}&typesummary=${Number(this.typesummary)}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.arrayItemsContainerSummary = response
      })
  }
  onviewAddProducts(){
    if (this.viewAddProduct) {
      this.viewAddProduct=false
    } else {
      this.viewAddProduct=true
    }
  

  }
  onviewConfirmProducts(){
    if (this.viewConfirmProduts) {
      this.viewConfirmProduts=false
    } else {
      this.viewConfirmProduts=true
    }
  

  }
  onviewBillofLadingProducts(){
    if (this.viewBillofLading) {
      this.viewBillofLading=false
    } else {
      this.viewBillofLading=true
    }
  

  }
  onclearConfirmProducts(){
    this.idEditItemsContainerConfirm=0
        this.labelAddConf = 'Add'
        this.FormConfirmItems.reset({
          itemsContainer: ['', Validators.required],
          palletNumber: [1],
          palletQty: [1],
          Qty: [1, Validators.required],
          typePallet: ['CTNS', Validators.required],
          weight_items: [0]
        })
      
     
        this.FormConfirmItems.controls.Qty.setValue(1)
        this.FormConfirmItems.controls.weight_items.setValue(0)
        this.FormConfirmItems.controls.typePallet.setValue('CTNS')
        this.FormConfirmItems.controls.itemsContainer.enable()
        this.selectitemsComfir.open()
        this.selectitemsComfir.focus()
        if (this.DataContenedor.custom.value == 1265) {
          this.FormConfirmItems.controls.palletNumber.setValue(null)
        this.FormConfirmItems.controls.palletQty.setValue(1)
        } else if (this.DataContenedor.custom.value == 1264) {
          this.FormConfirmItems.controls.palletNumber.setValue(1)
          this.FormConfirmItems.controls.palletQty.setValue(1)
        } else {
          this.FormConfirmItems.controls.palletNumber.setValue(1)
          this.FormConfirmItems.controls.palletQty.setValue(1)
        }
  }
}
